// extracted by mini-css-extract-plugin
export default {"wrapperInner":"wrapperInner--bXcjq","root":"root--vS4BW","collapseContainer":"collapseContainer--ViyNE"};